module.exports = __webpack_public_path__ + "img/service-white-icon3.6ee56b9a.png";